define('SageDotCom/DataLayer/Events/internalLinkClick',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ExitLinkClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "internal_link"; // overwrite name
    }

    ExitLinkClickEvent.prototype = Object.create(EventBase.prototype);

    ExitLinkClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "component",
            'event_action': "internal_link"
        }

        if (scope) {
            if ($(scope).hasClass("commerce-link")) {
                if (window.utag_data) {

                    let utagData = window.utag_data;

                    eventData = {
                        "site_environment": utagData.site_environment || "",
                        "site_platform": utagData.site_platform || "",
                        "event_name": $(scope).attr("name"),
                        "site_currency": utagData.site_currency || "",
                        "page_type": utagData.page_type || "",
                        "page_section": utagData.page_section || "",
                        "page_id": utagData.page_id !== "checkout_spa" ? utagData.page_id : "Account Details"
                    };
                }
            } else {
                var location = this.getLocation(scope);
                var lbl = label || $(scope).attr("data-title") || $(scope).text() || "";
                var scopeId = this.getId(scope);
                var lev3 = "";
                var lev4 = "";
                if (scopeId) {
                    if (scopeId.indexOf("BV_popover") !== -1) {
                        lev3 = "tooltip_popup";
                        lev4 = "existing sageid";
                    } else if (scopeId.indexOf("alertbox") !== -1) {
                        lev3 = "top_banner_popup";
                        lev4 = "existing sageid";
                    } else {
                        lev3 = "";
                        lev4 = location;
                    }
                }

                eventData = $.extend(eventData,
                    {
                        'event_label': this.stripHtml(lbl.trim()), // strip any html
                        'event_name_level_1': this.getId(scope),
                        'event_name_level_2': $(scope).attr("href") || $("a:first", scope).attr("href") || "",
                        'event_name_level_3': lev3,
                        'event_name_level_4': lev4
                    });
            }
        }

        return eventData;
    }

    return new ExitLinkClickEvent();
});
